module.exports = __webpack_public_path__ + "static/media/sergey_b.673c733a.jpg";